import React, { useState } from "react";
import { ThemeProvider } from "@emotion/react";
import sample from "lodash/fp/sample";
import { red, blue, green, gray } from "./themes";
import { useIntl } from "react-intl";
import { getCharacter } from "./character";

const AppContext = React.createContext([{}, () => {}]);

const AppContextProvider = (props) => {
  const { formatMessage } = useIntl();
  const [theme, setTheme] = useState(sample([red, blue, green, gray]));
  const [character, setCharacter] = useState(getCharacter({ formatMessage }));

  const setRandomTheme = () =>
    setTheme(
      sample(
        [red, blue, green, gray].filter(({ header }) => header !== theme.header)
      )
    );

  const reroll = () => {
    setCharacter(getCharacter({ formatMessage }));
    setRandomTheme();
  };

  return (
    <AppContext.Provider value={{ character, reroll }}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </AppContext.Provider>
  );
};

export { AppContextProvider };
export default AppContext;
